// Hash routes. Every page has an address, so Back, Forward and reload work,
// and nothing in the UI changes the page on its own: only links, keys and
// buttons the player presses call go(). Routes never touch the hunt, which
// runs on the server whatever page is open.
//
//   #/hunt (default)  #/kinhall  #/map  #/map/:region  #/map/:region/:area  #/creatures  #/creatures/team
//   #/creatures/favorites  #/creatures/for-sale  #/creature/:id  #/bag  #/bag/:pocket  #/shop  #/shop/:tab  #/shop/diamonds/skins
//   #/market  #/bosses (to the Trail's boss node while the Trail is on)  #/trail  #/trail/:region  #/trail/:region/:node  #/bestiary  #/bestiary/:species  #/help  #/calculator
//   #/admin  #/account  #/trainer  #/records  #/records/:species  #/leaderboards  #/leaderboards/:board  #/quests  #/guild  #/arena  #/halls  #/plan  #/tournaments
//   #/pass  #/friends  #/friends/:tab (requests, battles, training, blocked)  #/friends/chat/:name and #/messages/… (to Chat)  #/chat  #/chat/:channel  #/chat/inbox  #/chat/requests  #/chat/dm/:name  #/player/:name

/** sub2: a third part, as in #/map/:region/:area or #/creatures/team/shrines. */
export interface Route { page: string; sub: string; sub2: string }

export const PAGES = ['hunt', 'kinhall', 'map', 'creatures', 'creature', 'bag', 'shop', 'market', 'bosses', 'trail', 'bestiary', 'help', 'calculator', 'admin', 'account', 'trainer', 'records', 'leaderboards', 'quests', 'guild', 'arena', 'halls', 'plan', 'tournaments', 'worldboss', 'friends', 'player', 'pass', 'messages', 'chat'] as const;

export function parseHash(hash: string): Route {
  // Old share links (#c123) open the creature page.
  const old = hash.match(/^#c(\d+)$/);
  if (old) return { page: 'creature', sub: old[1], sub2: '' };
  const [page = 'hunt', sub = '', sub2 = ''] = hash.replace(/^#\/?/, '').split('/').map(decodeURIComponent);
  return (PAGES as readonly string[]).includes(page) ? { page, sub, sub2 } : { page: 'hunt', sub: '', sub2: '' };
}

export const route = () => parseHash(location.hash);

/** Navigations made inside the app this session; Close uses Back only when there is an in-app page to go back to. */
export let depth = 0;
window.addEventListener('hashchange', () => { depth++; });

export function go(path: string, replace = false) {
  if (location.hash === path) return;
  if (replace) { history.replaceState(null, '', path); window.dispatchEvent(new HashChangeEvent('hashchange')); }
  else location.hash = path;
}

/** Where each old sheet tab lives now. */
export const TAB_ROUTE: Record<string, string> = {
  map: '#/map', depot: '#/creatures', team: '#/creatures/team', bag: '#/bag', shop: '#/shop', market: '#/market',
  bosses: '#/bosses', dex: '#/bestiary', calc: '#/calculator', wiki: '#/help', admin: '#/admin', account: '#/account',
};
